  <app-breadcrumb-mkt [title]="title" [routeBase]="route"/>
  <button class="btn btn-outline-primary" type="button" data-bs-toggle="modal" data-bs-target="#modalAddUser">Agregar</button>

<hr class="w-100">


<div class="container">
  <div class="my-5">
    <ul id="icons-list" class="row row-cols-3 row-cols-sm-4 row-cols-lg-6 row-cols-xl-8 list-unstyled list">
      <li *ngFor="let item of usuarios; let i = index" class="col mb-4" data-name="0-circle" data-tags="number numeral"
          data-categories="shapes">

        <a  type="button" data-bs-toggle="modal" data-bs-target="#modalEditUser" (click)="edit(item._id)"

          class="d-block text-body-emphasis text-decoration-none">
          <div class="px-3 py-4 mb-2 bg-body-tertiary text-center rounded">

            <img src="{{item.avatar}}" style="width: 50px; height: 50px" class="img-fluid" alt="logoUser" fill>

          </div>
          <div class="d-flex justify-content-center align-items-center name text-muted text-decoration-none text-center pt-1">
<!--            <i  class="bi bi-circle-fill fw-light text-danger mx-1"></i>-->
            {{ item.username }}
          </div>
        </a>
      </li>
    </ul>
  </div>
</div>


<div  #addUserForm class="modal fade" id="modalAddUser" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Agregar Usuario</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form action="" [formGroup]="formAddUser">
          <div class="mb-3">
            <label for="emailUserMKT" class="form-label">Email</label>
            <input formControlName="email" type="email" class="form-control" id="emailUserMKT" placeholder="username@medilink.com.ec">
          </div>
          <div class="mb-3">
            <label for="usernameMKT" class="form-label">Username</label>
            <input formControlName="username"  type="text" class="form-control" id="usernameMKT" placeholder="username">
          </div>
          <div class="mb-3">
            <label for="passwordMKT" class="form-label">Password</label>
            <input formControlName="password"  type="password" class="form-control" id="passwordMKT" placeholder="password">
          </div>
          <div class="mb-3">
            <p>Status del Usuario</p>
            <div class="d-flex justify-content-evenly">
              <div class="form-check">
                <input value="true" formControlName="status" class="form-check-input" type="radio" name="flexRadioDefault" id="active">
                <label class="form-check-label" for="active">
                  Activo
                </label>
              </div>
              <div class="form-check">
                <input value="false" formControlName="status" class="form-check-input" type="radio" name="flexRadioDefault" id="inactive">
                <label class="form-check-label" for="inactive">
                  Inactivo
                </label>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <p>Rol del Usuario</p>
            <div class="d-flex justify-content-evenly" formArrayName="roles">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="user" id="user" (change)="onCheckboxAddChange($event)" />
                <label class="form-check-label" for="user"> Usuario </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="admin" id="admin" (change)="onCheckboxAddChange($event)" />
                <label class="form-check-label" for="admin"> Admin </label>
              </div>
            </div>
          </div>

        </form>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-outline-primary" (click)="sendAllData()">Guardar</button>
      </div>
    </div>
  </div>
</div>

<div #editUserForm class="modal fade" id="modalEditUser" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="editModalLabel">Editar Usuario</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form action="" [formGroup]="formEditUser">
          <div class="mb-3">
            <label for="emailUserMKT" class="form-label">Email</label>
            <input formControlName="email" type="email" class="form-control" id="editEmailUserMKT" placeholder="username@medilink.com.ec">
          </div>
          <div class="mb-3">
            <label for="usernameMKT" class="form-label">Username</label>
            <input formControlName="username"  type="text" class="form-control" id="editUsernameMKT" placeholder="username">
          </div>
          <!--<div class="mb-3">
            <label for="passwordMKT" class="form-label">Password</label>
            <input formControlName="password"  type="password" class="form-control" id="editPasswordMKT" placeholder="password">
          </div>-->
          <div class="mb-3">
            <p>Status del Usuario</p>
            <div class="d-flex justify-content-evenly">
              <div class="form-check">
                <input  value="true" formControlName="status" class="form-check-input" type="radio" name="flexRadioDefault" id="editActive">
                <label class="form-check-label" for="editActive"> Activo </label>
              </div>
              <div class="form-check">
                <input value="false" formControlName="status" class="form-check-input" type="radio" name="flexRadioDefault" id="editInactive">
                <label class="form-check-label" for="editInactive"> Inactivo </label>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <p>Rol del Usuario</p>
            <div class="d-flex justify-content-evenly" formArrayName="roles">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="user" id="userEdit" (change)="onCheckboxEditChange($event)" />
                <label class="form-check-label" for="userEdit"> Usuario </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="admin" id="adminEdit" (change)="onCheckboxEditChange($event)" />
                <label class="form-check-label" for="adminEdit"> Admin </label>
              </div>
            </div>
          </div>

        </form>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-outline-primary" (click)="editAllData()">Guardar</button>
      </div>
    </div>
  </div>
</div>




  <app-notifications/>
